<template>
    <v-app>
        <v-card
            flat
            tile
        >
            <v-app-bar
                v-if="drawer"
                dark
                color="#3263AD"
                fixed
                elevation="6"
            >
                <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->

                <!-- <v-toolbar-title @click="Nav('dashboard')">CRM</v-toolbar-title> -->
                <v-img
                    src="images/DIGITALTUGUEGARAOstroke.png"
                    max-width="200"
                    contain
                    @click="menudrawer = true"
                    style="cursor: pointer;"
                ></v-img>

                <v-spacer></v-spacer>

                <!-- <v-btn icon @click="Nav('dashboard')">
                    <v-icon>mdi-bank-transfer-in</v-icon>
                </v-btn> -->

                <!-- <v-menu
                    open-on-hover
                    offset-y
                    left
                    bottom
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="white"
                            dark
                            text
                            rounded
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon>mdi-bank-transfer-in</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item @click="OP_Transactions">
                            <v-list-item-title>Transactions</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="BPLOPayment">
                            <v-list-item-title>Business License</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="RPT">
                            <v-list-item-title>Real Property Tax</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <v-menu
                    open-on-hover
                    offset-y
                    left
                    bottom
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="white"
                            dark
                            text
                            rounded
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon>mdi-store</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item @click="BPLONew">
                            <v-list-item-title>New</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="BPLORenewal">
                            <v-list-item-title>Renewal</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="Nav('bploretirement')">
                            <v-list-item-title>Retirement</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu> -->

                <!-- <v-btn icon @click="FileManagement">
                    <v-icon>mdi-file-document-outline</v-icon>
                </v-btn> -->

                <!-- <v-menu
                    open-on-hover
                    offset-y
                    left
                    bottom
                    v-if="ch_employee"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="white"
                            dark
                            text
                            rounded
                            v-bind="attrs"
                            v-on="on"
                        >
                            <template v-if="notifications.documentapproval && parseInt(notifications.documentapproval) > 0">
                                <v-badge
                                    color="red"
                                    :content="notifications.documentapproval"
                                >
                                    <v-icon>mdi-thumb-up-outline</v-icon>
                                </v-badge>
                            </template>
                            <template v-else>
                                <v-icon>mdi-thumb-up-outline</v-icon>
                            </template>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item @click="Nav('documentapproving')">
                            <v-list-item-title>Document Upload</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="Nav('documentapproval')">
                            <v-list-item-title class="pr-4">
                                <template v-if="notifications.documentapproval && parseInt(notifications.documentapproval) > 0">
                                    <v-badge
                                        color="red"
                                        :content="notifications.documentapproval"
                                    >
                                        Document for your Approval
                                    </v-badge>
                                </template>
                                <template v-else>
                                    Document for your Approval
                                </template>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu> -->

                <v-btn icon @click="Profile">
                    <v-avatar color="red darken-3" size="40">
                        <!-- <span class="white--text">{{ context.initials }}</span> -->
                        <img
                            v-if="profilepicloaded"
                            alt="Avatar"
                            :src="profilepic"
                        />
                        <span class="white--text" v-else>{{ initials }}</span>
                    </v-avatar>
                </v-btn>

                <v-btn icon @click="Logout">
                    <v-icon>mdi-logout</v-icon>
                </v-btn>

                <!-- <v-btn icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn> -->
            </v-app-bar>
        </v-card>

        <v-navigation-drawer
            v-model="menudrawer"
            fixed
            temporary
            width="400"
            dark
            v-if="drawer"
        >
            <v-list-item class="mt-2 mb-2">
                <v-list-item-content>
                    <v-list-item-title>Welcome to Digital Tuguegarao!</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item @click="Profile">
                <v-avatar color="red darken-3" size="36">
                    <img
                        v-if="profilepicloaded"
                        alt="Avatar"
                        :src="profilepic"
                    />
                    <span class="white--text" v-else>{{ fullname }}</span>
                </v-avatar>

                <v-list-item-content>
                    <v-list-item-title class="ml-4">{{ fullname }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list>
                <v-list-item-content @click="Nav('dashboard')" class="ml-4" style="cursor: pointer;">
                    <v-list-item-title><v-icon class="mr-2">mdi-monitor-dashboard</v-icon>Dashboard</v-list-item-title>
                </v-list-item-content>

                <v-list-item-content @click="Nav('tdnclaims')" class="ml-4" style="cursor: pointer;">
                    <v-list-item-title><v-icon class="mr-2">mdi-file-document-edit-outline</v-icon>Tax Declaration Number Claims</v-list-item-title>
                </v-list-item-content>

                <v-list-item-content @click="Nav('bizclaims')" class="ml-4" style="cursor: pointer;">
                    <v-list-item-title><v-icon class="mr-2">mdi-file-document-edit-outline</v-icon>Business Claims</v-list-item-title>
                </v-list-item-content>

                <!-- mdi-text-box-check-outline -->
                <v-list-item-content @click="Nav('tdnclaimsapproval')" class="ml-4" style="cursor: pointer;" v-if="ch_employee && divisions.includes('Assessor')">
                    <v-list-item-title><v-icon class="mr-2">mdi-alert-circle-check-outline</v-icon>TDN Claims Approval</v-list-item-title>
                </v-list-item-content>

                <v-list-item-content @click="Nav('bizclaimsapproval')" class="ml-4" style="cursor: pointer;" v-if="ch_employee && divisions.includes('BPLO')">
                    <v-list-item-title><v-icon class="mr-2">mdi-alert-circle-check-outline</v-icon>Business Claims Approval</v-list-item-title>
                </v-list-item-content>

                <v-list-item-content @click="Nav('documentapproving')" v-if="ch_employee" class="ml-4" style="cursor: pointer;">
                    <v-list-item-title><v-icon class="mr-2">mdi-file-upload-outline</v-icon>Document Outbox</v-list-item-title>
                </v-list-item-content>

                <v-list-item-content @click="Nav('documentapproval')" v-if="ch_employee" class="ml-4" style="cursor: pointer;">
                    <template v-if="notifications.documentapproval && parseInt(notifications.documentapproval) > 0">
                        <v-badge
                            color="red"
                            :content="notifications.documentapproval"
                            overlap
                            :offset-x="230"
                        >
                            <v-list-item-title><v-icon class="mr-2">mdi-thumb-up-outline</v-icon>Document Inbox</v-list-item-title>
                        </v-badge>
                    </template>
                    <template v-else>
                        <v-list-item-title><v-icon class="mr-2">mdi-thumb-up-outline</v-icon>Document Inbox</v-list-item-title>
                    </template>
                </v-list-item-content>

                <v-list-item-content @click="Nav('onlinepaymentransactions')" class="ml-4" style="cursor: pointer;">
                    <v-list-item-title><v-icon class="mr-2">mdi-credit-card-wireless-outline</v-icon>Online Transactions</v-list-item-title>
                </v-list-item-content>
            </v-list>

            <template v-slot:append>
                <div class="mt-5 pa-2">
                    <v-btn block @click="Logout" color="red darken-1" dark>
                        <v-icon class="mr-2">mdi-logout</v-icon>Logout
                    </v-btn>
                </div>
            </template>
        </v-navigation-drawer>

        <!-- <v-navigation-drawer
            dark
            app
            permanent
            expand-on-hover
            mini-variant
            absolute
            v-if="drawer"
            color="blue-grey darken-4"
            style="z-index: 1999"
        >
            <v-list>
                <v-list-item class="px-2">
                    <v-list-item-avatar>
                        <v-avatar color="red" size="36">
                            <span class="white--text">{{ initials }}</span>
                        </v-avatar>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>{{ fullname }}</v-list-item-title>
                        <v-list-item-subtitle>{{ username }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list
                nav
                dense
            >
                <v-list-item link @click="Profile">
                    <v-list-item-icon>
                        <v-icon>mdi-account-box-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Profile</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="Logout">
                    <v-list-item-icon>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Logout</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-navigation-drawer> -->

        <div class="d-none">
            <img class="img-fluid" :src="profilepic" @load="LoadedProfilePic">
        </div>
        
        <v-main style="margin-top: 4em;">
            <transition name="slide">
                <router-view @updatesession="UpdateSession" @ol="OL" @snackbar="Snackbar" @updatenotif="Notifications" :GenerateUB_Cipher="GenerateUB_Cipher" :randHex="randHex" :UpdateTransactionUB="UpdateTransactionUB" :CheckIfLoggedInInternal="CheckIfLoggedInInternal"></router-view>
            </transition>
        </v-main>

        <v-footer
            dark
            padless
            color="#3263AD"
            class="pa-4 mt-6 d-none"
        >
            <v-card
                flat
                tile
                class="flex"
                color="#3263AD"
            >
                <v-card-text class="py-2 white--text text-center">
                    {{ new Date().getFullYear() }} — <strong></strong>
                </v-card-text>
            </v-card>
        </v-footer>

        <v-overlay :value="overlayloading" style="z-index: 2000;">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar
            v-model="showSnackbar"
            :color="snackbarVariant"
            :timeout="snackbarTimeout"
            top
            centered
            elevation="24"
            style="z-index: 9999;"
            class="mt-6"
        >
            <v-layout color="transparent" dark>{{ modalMessage }}</v-layout>
            <template v-slot:action="{ attrs }">
                <v-btn
                    dark
                    text
                    v-bind="attrs"
                    @click="showSnackbar = false"
                >
                    <i class="mdi mdi-close"></i>
                </v-btn>
            </template>
        </v-snackbar>

        <v-snackbar
            v-model="versionsnackbar"
            :timeout="99999999999999999999"
            class="d-none"
        >
            Update to the new version by clicking <v-btn small dark text color="white" @click="NewVersion">here</v-btn>.
        </v-snackbar>
    </v-app>
</template>

<script>
import axios from "axios"
import moment from "moment"
import _ from "lodash"

export default {
    name: 'App',
    metaInfo: {
        title: 'Citizen Relationship Management',
    },
    data() {
        return {
            versionsnackbar: false,
            menudrawer: false,
            notificationsint: null,
            notifications: {},
            profilepic: '',
            profilepicloaded: false,
            overlayloading: false,
            drawer: false,
            username: '',
            initials: '',
            fullname: '',
            showSnackbar: false,
            snackbarVariant: 'red darken-3',
            snackbarTimeout: 3000,
            modalMessage: '',
            ch_employee: false,
            divisions: [],
            versionchecker: null,
            newversion: '',
            logincheckerint: null,

            // ub credentials from server
            ub: {
                key: '',
                uuid: '',
                whitelabelpage: '',
            }
        }
    },
    watch: {
        drawer(newValue, oldValue) {
            console.log(newValue)
            console.log(oldValue)
        },
    },
    methods: {
        LoadedProfilePic() {
            this.profilepicloaded = true
        },
        OL(oldisplay) {
            this.overlayloading = oldisplay
        },
        Snackbar(details) {
            this.showSnackbar = true
            this.snackbarVariant = details.variant
            this.modalMessage = details.message
            this.snackbarTimeout = details.timeout || 3000
        },
        Nav(link) {
            this.$router.push({
                name: link.toString(),
            }).catch(() => {})
        },
        OP_Transactions() {
            this.$router.push({
                name: 'onlinepaymentransactions'
            }).catch(() => {})
        },
        RPT() {
            this.$router.push({
                name: 'rptpayment'
            }).catch(() => {})
        },
        BPLOPayment() {
            this.$router.push({
                name: 'bplopayment'
            }).catch(() => {})
        },
        PaymentTest() {
            this.$router.push({
                name: 'payment'
            }).catch(()=>{})
        },
        BPLORenewal() {
            this.$router.push({
                name: 'bplorenewal'
            }).catch(()=>{})
        },
        BPLONew() {
            this.$router.push({
                name: 'bplonew'
            }).catch(()=>{})
        },
        FileManagement() {
            this.$router.push({
                name: 'filerepo'
            }).catch(()=>{})
        },
        Profile() {
            this.$router.push({
                name: 'profile'
            }).catch(()=>{})
        },
        Logout() {
            // this.$session.destroy()

            // this.$ls.remove('isLoggedIn')

            // localStorage.removeItem('app-xstate')

            // this.$router.push({
            //     name: 'login'
            // })

            window.location = `${this.localdomain}logout?redirect=${this.localdomain}`
        },
        UpdateSession(e) {
            this.drawer = e

            if(e){
                this.SessionDetails()
            }
        },
        SessionDetails() {
            const { username, user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)

            // console.log(user)
            this.ch_employee = user.ch_employee

            this.divisions = user.ch_divisions || []

            this.username = username.toString()

            this.initials = user.accounttype.toString() == 'individual' ? `${user.firstname.substr(0,1)}${user.lastname.substr(0,1)}`.toUpperCase() : user.companyname.replace(/[^\w\d\s]/g, '').split(' ').map(x => {
                return x[0].toString()
            }).join('').toUpperCase()

            this.fullname = user.accounttype.toString() == 'individual' ? user.fullname_format1.toString() : user.companyname.toString()

            if(user.imgUrl){
                this.profilepic = `${this.domain}/serve/staticfiles/${user.imgUrl.replace('public/files/', '')}`
            }
        },
        Notifications() {
            if (this.$session.exists() && this.$session.get('crmusersessionsignature')) {
                const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)

                if(user._id){
                    axios({
                        method: 'post',
                        url: `${this.domain}/crm_citizen_notifications`,
                        data: {
                            userid: user._id.toString(),
                        }
                    })
                        .then(response => {
                            if(response.data.response){
                                const notif = this.$jwt.decode(response.data.notifications, this.jwtsecret)

                                this.notifications = notif.notifications
                            }
                        })
                }
            }
        },
        VersionChecker() {
            axios({
                method: 'get',
                url: `${this.localdomain.replace('#/', '')}version.json`,
            })
                .then(response => {
                    if(response.data.version && response.data.version.toString().length > 0){
                        this.newversion = response.data.version.toString()

                        if(!this.$session.get('crmversion')){
                            // this.$session.set('crmversion', response.data.version)
                            this.versionsnackbar = true
                        } else{
                            if(this.$session.get('crmversion') !== response.data.version){
                                this.versionsnackbar = true
                            }
                        }
                    }
                })
        },
        NewVersion() {
            this.$session.set('crmversion', this.newversion)

            this.$router.go()
        },
        randHex(len) {
            var maxlen = 8
            var min = Math.pow(16,Math.min(len,maxlen)-1) 
            var max = Math.pow(16,Math.min(len,maxlen)) - 1
            var n   = Math.floor( Math.random() * (max-min+1) ) + min
            var r   = n.toString(16)
            while ( r.length < len ) {
                r = r + this.randHex( len - maxlen )
            }
            return r
        },
        UpdateTransactionUB(details, cb = () => {}) {
            axios({
                method: 'post',
                url: `${this.domain}/ubtransactions/updateubtransaction`,
                data: {
                    requestid: details.id.toString(),
                    data: details.data,
                }
            })
                .then(response => {
                    if(response.data.response) {
                        cb()
                    }
                })
        },
        GenerateUB_Cipher(details) {
            const udetails = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)

            const iv = this.randHex(32)

            const sampledata = {
                "Amt": parseFloat(details.Amt),
                // "Amt": 1,
                "Email": udetails.user.email.toString(),
                // "Email": "no-reply@gmail.com",
                "Mobile": _.trimStart(udetails.user.mobile.toString(), '+63'),
                "Redir": details.Redir.toString(),
                "References":[
                    {
                        "Id": "1",
                        "Name": "TRANSACTION ID",
                        "Val": details.TransactionId,
                    },
                    {
                        "Id": "2",
                        "Name": "TRANSACTION TYPE",
                        "Val": details.TransactionType
                    },
                    {
                        "Id": "3",
                        "Name": "DEPARTMENT",
                        "Val": details.Department
                    },
                    {
                        "Id": "4",
                        "Name": "PAYOR LAST NAME",
                        "Val": udetails.user.lastname.toString()
                    },
                    {
                        "Id": "5",
                        "Name": "PAYOR FIRST NAME",
                        "Val": udetails.user.firstname.toString()
                    },
                ]
            }

            // console.log(sampledata)

            const biv = this.$CryptoJS.enc.Hex.parse(iv)

            const payload = this.$CryptoJS.AES.encrypt(this.$CryptoJS.enc.Utf8.parse(JSON.stringify(sampledata)), this.$CryptoJS.enc.Hex.parse(this.ub.key), {
                mode: this.$CryptoJS.mode.CBC,
                padding: this.$CryptoJS.pad.Pkcs7,
                iv: biv,
            })

            const cipher = encodeURIComponent(`${this.$CryptoJS.enc.Base64.stringify(biv)}${payload}`)
            // UAT
            // const url = `${this.ub.whitelabelpage}${this.ub.uuid}/${cipher}`
            // 1.13
            const url = `${this.ub.whitelabelpage}${this.ub.uuid}?s=${cipher}`

            // window.open(url, '_blank')
            return {
                url,
                data: sampledata,
            }
        },
        UBC() {
            axios({
                method: 'post',
                url: `${this.domain}/ubc`,
                data: {
                    rand: Math.random(),
                }
            })
                .then(response => {
                    if(response.data.response) {
                        const ub = this.$jwt.decode(response.data.ub, this.jwtsecret)

                        this.ub = {
                            key: ub.key,
                            uuid: ub.uuid,
                            whitelabelpage: ub.whitelabelpage,
                        }
                    }
                })
        },
        CheckIfLoggedInInternal() {
            if(!this.$session.has('crmusersessionsignature')) {
                this.Logout()
            }
        }
    },
    mounted() {
        if (this.$session.exists() && this.$session.get('crmusersessionsignature')) {
            this.drawer = true

            this.SessionDetails()
        }

        this.Notifications()

        this.notificationsint = setInterval(() => {
            this.Notifications()
        }, 60000)

        window.addEventListener('storage', (ev) => {
            if(ev.key.toString() == 'tuguecrmuserisLoggedIn' && ev.newValue !== null){
                const nv = JSON.parse(ev.newValue)
                if(nv.value && nv.value == true){
                    this.UpdateSession(true)
                }
            }
        })
        this.VersionChecker()
        this.versionchecker = setInterval(() => {
            this.VersionChecker()
        }, 300000)

        this.logincheckerint = setInterval(() => {
            if (this.$session.exists() && this.$session.get('crmusersessionsignature')) {
                this.$session.set('crmusersessiontimer', moment().unix())
            }
        }, 10000)

        if (this.$session.exists() && this.$session.get('crmusersessionsignature')) {
            // check login timer
            if(!this.$session.get('crmusersessiontimer')){
                this.$router.push({
                    name: 'logout'
                }).catch(()=>{})
            } else{
                const diff = Math.abs(moment().diff(moment(parseInt(this.$session.get('crmusersessiontimer')) * 1000), 'days'))

                // console.log(diff)
                if(parseFloat(diff) >= 3){
                    this.$router.push({
                        name: 'logout'
                    }).catch(()=>{})
                }
            }
        }

        this.UBC()
    },
    beforeDestroy() {
        if(this.notificationsint){
            clearInterval(this.notificationsint)
        }

        if(this.logincheckerint){
            clearInterval(this.logincheckerint)
        }

        if(this.versionchecker){
            clearInterval(this.versionchecker)
        }
    }
}
</script>

<style>
@import 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900';
@import 'https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css';
</style>